export enum PlanType {
    Unknown = 0,
    Trial = 1,
    Basic = 2,
    Advance = 3,
    Enterprise = 4,
    Suisse = 5
}
